<template>
  <div class="sidebar" @click.stop="() => {}">
    <div class="main-menu">
      <vue-perfect-scrollbar
        class="scroll"
        :settings="{ suppressScrollX: true, wheelPropagation: false }"
      >
        <ul class="list-unstyled">
          <li class="d-xs-block d-md-none">
            <router-link to="/">
              <img
                src="../../assets/img/logo-small.png"
                class="logo mb-2"
              />خانه
            </router-link>
          </li>
          <li :class="{ active: this.$route.fullPath === '/school' }">
            <router-link to="/school">
              <i class="icon-Home-5"></i>مدارس
            </router-link>
          </li>
          <li :class="{ active: this.$route.fullPath === '/student' }">
            <router-link to="/student">
              <i
                :class="
                  CurrentUser.gender_limit && CurrentUser.gender === 'female'
                    ? 'icon-Girl'
                    : 'icon-Male'
                "
              ></i
              >دانش‌آموزان
            </router-link>
          </li>
          <li :class="{ active: this.$route.fullPath === '/mentor' }">
            <router-link to="/mentor">
              <i
                :class="
                  CurrentUser.gender_limit && CurrentUser.gender === 'female'
                    ? 'icon-Student-Female'
                    : 'icon-Student-Male'
                "
              ></i
              >شبکه پشتیبان
            </router-link>
          </li>
          <li :class="{ active: this.$route.fullPath === '/platoon' }">
            <router-link to="/platoon">
              <i class="icon-Sheriff-Badge"></i>قرارگاه‌ها
            </router-link>
          </li>
          <li
            :class="{ active: this.$route.fullPath.startsWith('/school/') }"
            v-show="School.slug"
          >
            <router-link :to="'/school/' + School.slug">
              <i class="icon-Home-5"></i>
              <div class="text-center">{{ School.name }}</div>
            </router-link>
          </li>
          <li
            :class="{ active: this.$route.fullPath.startsWith('/user/') }"
            v-show="User.slug"
          >
            <router-link :to="'/user/' + User.slug">
              <i
                :class="
                  User.gender === 'male'
                    ? 'icon-Business-Man'
                    : 'icon-Business-Woman'
                "
              ></i>
              <div class="text-center">
                {{ User.first_name }} {{ User.last_name }}
              </div>
            </router-link>
          </li>
          <li
            :class="{ active: this.$route.fullPath.startsWith('/platoon/') }"
            v-show="Platoon.slug"
          >
            <router-link :to="'/platoon/' + Platoon.slug">
              <i class="icon-Sheriff-Badge"></i>
              <div class="text-center">{{ Platoon.name }}</div>
            </router-link>
          </li>
        </ul>
      </vue-perfect-scrollbar>
    </div>

    <div class="sub-menu text-center pr-3">
      <b-form-group
        label="دسته"
        class="has-float-label my-4 ml-3"
        v-show="showTeamCategory"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.team_category"
          @change="teamCategoryChange"
          :options="CurrentUser.team_category_list"
        />
      </b-form-group>

      <b-form-group
        label="گروه"
        class="has-float-label my-4 ml-3"
        v-show="showGroup"
        :disabled="Reloading"
      >
        <b-select size="sm" v-model="menu.group" @change="teamGroupChange">
          <b-select-option value="2">مربیان</b-select-option>
          <b-select-option value="5">فرهنگیان</b-select-option>
          <b-select-option value="3">کادر</b-select-option>
        </b-select>
      </b-form-group>

      <b-form-group
        label="استان"
        class="has-float-label my-4 ml-3"
        v-show="showProvince"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.province"
          @change="provinceChange"
          value-field="id"
          text-field="name"
          :options="CurrentUser.province_list"
        />
      </b-form-group>

      <b-form-group
        label="شهرستان"
        class="has-float-label my-4 ml-3"
        v-show="showCounty"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.county"
          @change="countyChange"
          :options="CurrentUser.county_list"
          value-field="id"
          text-field="name"
        />
      </b-form-group>

      <b-form-group
        label="شهر"
        class="has-float-label my-4 ml-3"
        v-show="showCity"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.city"
          @change="cityChange"
          :options="CurrentUser.city_list"
          value-field="id"
          text-field="name"
        />
      </b-form-group>

      <b-form-group
        label="جنسیت"
        class="has-float-label my-4 ml-3"
        v-show="showGender"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.gender"
          @change="GenderChange"
          :options="CurrentUser.gender_list"
        />
      </b-form-group>

      <b-form-group
        label="مقطع"
        class="has-float-label my-4 ml-3"
        v-show="showGrade"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.grade"
          @change="gradeChange"
          :options="this.$store.state.grade_list"
        />
      </b-form-group>

      <b-form-group
        label="فعال"
        class="has-float-label my-4 ml-3"
        v-show="showActive"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.active"
          @change="activeChange"
          :options="this.$store.state.active_list"
        />
      </b-form-group>

      <b-form-group
        label="پایه"
        class="has-float-label my-4 ml-3"
        v-show="showStep"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.step"
          @change="stepOrRoleChange"
          :options="this.$store.state.step_list"
        />
      </b-form-group>
      <b-form-group
        label="آرشیو"
        class="has-float-label my-4 ml-3"
        v-show="showActive"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.archive"
          @change="archiveChange"
          :options="this.$store.state.archive_list"
        />
      </b-form-group>
      <b-form-group
        label="سطح"
        class="has-float-label my-4 ml-3"
        v-show="showLevel"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.level"
          @change="levelChange"
          :options="$store.state.level_list"
        />
      </b-form-group>

      <b-form-group
        label="نقش"
        class="has-float-label my-4 ml-3"
        v-show="showRole"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.role"
          @change="stepOrRoleChange"
          :options="this.$store.state.role_list"
        />
      </b-form-group>

      <b-form-group
        label="احراز هویت"
        class="has-float-label my-4 ml-3"
        v-show="showTrust"
        :disabled="Reloading"
      >
        <b-select
          size="sm"
          v-model="menu.trust"
          @change="TrustChange"
          :options="[
            { value: null, text: 'نامشخص' },
            { value: 'True', text: 'بله' },
            { value: 'False', text: 'خیر' },
          ]"
        />
      </b-form-group>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      menu: {},
    };
  },
  created() {
    this.menu = this.$store.state.menu;
  },
  methods: {
    teamCategoryChange() {
      this.$store.commit("setTeamPageIsUpdate", false);
      if (this.$route.fullPath === "/teams")
        this.$store.dispatch("reloadTeamList");
    },
    teamGroupChange() {
      this.$store.commit("setMentorPageIsUpdate", false);
      this.$store.dispatch("reloadMentorList");
    },
    provinceChange() {
      this.$store.commit("setTeamPageIsUpdate", false);
      this.$store.commit("setSchoolPageIsUpdate", false);
      this.$store.commit("setStudentPageIsUpdate", false);
      this.$store.commit("setMentorPageIsUpdate", false);
      this.$store.commit("setPlatoonPageIsUpdate", false);

      axios
        .get("list-county/", { params: { province: this.menu.province } })
        .then((res) => {
          this.$store.commit("setCountyList", res.data);
          this.$store.commit("setCityList", []);
          if (this.$route.fullPath === "/teams")
            this.$store.dispatch("reloadTeamList");
          else if (this.$route.fullPath === "/school")
            this.$store.dispatch("reloadSchoolList");
          else if (this.$route.fullPath === "/student")
            this.$store.dispatch("reloadStudentList");
          else if (this.$route.fullPath === "/mentor")
            this.$store.dispatch("reloadMentorList");
          else if (this.$route.fullPath === "/platoon")
            this.$store.dispatch("reloadPlatoonList");
        });
    },
    countyChange() {
      this.$store.commit("setTeamPageIsUpdate", false);
      this.$store.commit("setSchoolPageIsUpdate", false);
      this.$store.commit("setStudentPageIsUpdate", false);
      this.$store.commit("setMentorPageIsUpdate", false);
      this.$store.commit("setPlatoonPageIsUpdate", false);

      if (this.menu.county)
        axios
          .get("list-city/", { params: { county: this.menu.county } })
          .then((res) => {
            this.$store.commit("setCityList", res.data);
            if (this.$route.fullPath === "/teams")
              this.$store.dispatch("reloadTeamList");
            else if (this.$route.fullPath === "/school")
              this.$store.dispatch("reloadSchoolList");
            else if (this.$route.fullPath === "/student")
              this.$store.dispatch("reloadStudentList");
            else if (this.$route.fullPath === "/mentor")
              this.$store.dispatch("reloadMentorList");
            else if (this.$route.fullPath === "/platoon")
              this.$store.dispatch("reloadPlatoonList");
          });
      else {
        this.$store.commit("setCityList", [{ id: 0, name: "همه" }]);
        if (this.$route.fullPath === "/teams")
          this.$store.dispatch("reloadTeamList");
        else if (this.$route.fullPath === "/school")
          this.$store.dispatch("reloadSchoolList");
        else if (this.$route.fullPath === "/student")
          this.$store.dispatch("reloadStudentList");
        else if (this.$route.fullPath === "/mentor")
          this.$store.dispatch("reloadMentorList");
        else if (this.$route.fullPath === "/platoon")
          this.$store.dispatch("reloadPlatoonList");
      }
    },
    cityChange() {
      this.$store.commit("setSchoolPageIsUpdate", false);
      this.$store.commit("setStudentPageIsUpdate", false);
      this.$store.commit("setMentorPageIsUpdate", false);
      this.$store.commit("setPlatoonPageIsUpdate", false);

      if (this.$route.fullPath === "/school")
        this.$store.dispatch("reloadSchoolList");
      else if (this.$route.fullPath === "/student")
        this.$store.dispatch("reloadStudentList");
      else if (this.$route.fullPath === "/mentor")
        this.$store.dispatch("reloadMentorList");
      else if (this.$route.fullPath === "/platoon")
        this.$store.dispatch("reloadPlatoonList");
    },
    GenderChange() {
      this.$store.commit("setTeamPageIsUpdate", false);
      this.$store.commit("setSchoolPageIsUpdate", false);
      this.$store.commit("setStudentPageIsUpdate", false);
      this.$store.commit("setMentorPageIsUpdate", false);
      this.$store.commit("setPlatoonPageIsUpdate", false);

      if (this.$route.fullPath === "/teams")
        this.$store.dispatch("reloadTeamList");
      else if (this.$route.fullPath === "/school")
        this.$store.dispatch("reloadSchoolList");
      else if (this.$route.fullPath === "/student")
        this.$store.dispatch("reloadStudentList");
      else if (this.$route.fullPath === "/mentor")
        this.$store.dispatch("reloadMentorList");
      else if (this.$route.fullPath === "/platoon")
        this.$store.dispatch("reloadPlatoonList");
    },
    gradeChange() {
      this.$store.commit("setSchoolPageIsUpdate", false);
      this.$store.commit("setPlatoonPageIsUpdate", false);
      if (this.$route.fullPath === "/school")
        this.$store.dispatch("reloadSchoolList");
      else this.$store.dispatch("reloadPlatoonList");
    },
    archiveChange() {
      this.$store.commit("setSchoolPageIsUpdate", false);
      if (this.$route.fullPath === "/school")
        this.$store.dispatch("reloadSchoolList");

    },
    activeChange() {
      this.$store.commit("setSchoolPageIsUpdate", false);
      this.$store.commit("setMentorPageIsUpdate", false);
      if (this.$route.fullPath === "/school")
        this.$store.dispatch("reloadSchoolList");
      else this.$store.dispatch("reloadMentorList");
    },
    stepOrRoleChange() {
      this.$store.commit("setStudentPageIsUpdate", false);
      this.$store.dispatch("reloadStudentList");
    },
    TrustChange() {
      this.$store.commit("setStudentPageIsUpdate", false);
      this.$store.commit("setMentorPageIsUpdate", false);
      if (this.$route.fullPath === "/student")
        this.$store.dispatch("reloadStudentList");
      else this.$store.dispatch("reloadMentorList");
    },
    levelChange() {
      this.$store.commit("setMentorPageIsUpdate", false);
      this.$store.commit("setPlatoonPageIsUpdate", false);
      if (this.$route.fullPath === "/mentor")
        this.$store.dispatch("reloadMentorList");
      else this.$store.dispatch("reloadPlatoonList");
    },
  },
  computed: {
    ...mapGetters(["CurrentUser", "School", "User", "Platoon", "Reloading"]),
    showTeamCategory() {
      return this.$route.fullPath === "/teams";
    },
    showGroup() {
      return this.$route.fullPath === "/mentor";
    },
    showProvince() {
      return (
        (this.$route.fullPath === "/school" ||
          this.$route.fullPath === "/student" ||
          this.$route.fullPath === "/mentor" ||
          this.$route.fullPath === "/platoon" ||
          this.$route.fullPath === "/teams") &&
        !this.$store.state.currentUser.province_limit
      );
    },
    showCounty() {
      return (
        (this.$route.fullPath === "/school" ||
          this.$route.fullPath === "/student" ||
          this.$route.fullPath === "/mentor" ||
          this.$route.fullPath === "/platoon" ||
          this.$route.fullPath === "/teams") &&
        !this.$store.state.currentUser.county_limit
      );
    },
    showCity() {
      return (
        this.$route.fullPath === "/school" ||
        this.$route.fullPath === "/student" ||
        this.$route.fullPath === "/mentor" ||
        this.$route.fullPath === "/platoon"
      );
    },
    showGender() {
      return (
        (this.$route.fullPath === "/school" ||
          this.$route.fullPath === "/student" ||
          this.$route.fullPath === "/mentor" ||
          this.$route.fullPath === "/platoon" ||
          this.$route.fullPath === "/teams") &&
        !this.$store.state.currentUser.gender_limit
      );
    },
    showGrade() {
      return (
        this.$route.fullPath === "/school" ||
        this.$route.fullPath === "/platoon"
      );
    },
    showActive() {
      return (
        this.$route.fullPath === "/school" || this.$route.fullPath === "/mentor"
      );
    },
    showStep() {
      return this.$route.fullPath === "/student";
    },
    showLevel() {
      return (
        this.$route.fullPath === "/platoon" ||
        (this.$route.fullPath === "/mentor" && this.menu.group === "2")
      );
    },
    showRole() {
      return this.$route.fullPath === "/student";
    },
    showTrust() {
      return (
        this.$route.fullPath === "/student" ||
        this.$route.fullPath === "/mentor"
      );
    },
  },
};
</script>
